import BackgroundActions from './actions-types'
import BackgroundMutations from './mutations-types'
import EntryMutations from '@/store/content/entry/mutations-types'
import axios from "axios";
import { BgActionEventBus } from '@/bgActionEventBus';

const isShareDownloadAction = (message) => ['share-download', 'share_download']
  .includes(String(message.type).toLowerCase())

const containsHttpUrl = (value) => {
  if (typeof value === 'string') {
    try {
      return containsHttpUrl(JSON.parse(value))
    } catch (error) {
      return /https?:\/\/[^\s<>"')\]]+/.test(value)
    }
  }

  if (!value || typeof value !== 'object') {
    return false
  }

  return Object.values(value).some(containsHttpUrl)
}

export default {
  [BackgroundActions.CREATE_BACKGROUND_ACTION]({ commit }, message) {
    const source = axios.CancelToken.source();
    const bgActionId = message.bgActionId ?? Math.random().toString(36).substr(2, 9)

    const bgAction = {
      bgActionId: bgActionId,
      bgGroupId: message.bgGroupId,
      title: message.title,
      type: message.type,
      icon: message.icon,
      text: message.text,
      createdAt: new Date(),
      progress: message.progress ?? 0,
      status: message.status ?? 'in_progress',
      cancelSource: source
    }

    commit(BackgroundMutations.REGISTER_BACKGROUND_ACTION, bgAction)

    return bgAction
  },

  [BackgroundActions.CREATE_OR_UPDATE_BACKGROUND_ACTION]({ commit, dispatch, state }, message) {
    let item = state.list.find(item => item.bgActionId == message.bgActionId)
    BgActionEventBus.$emit('bgAction', message)

    if (item) {
      commit(BackgroundMutations.UPDATE_BACKGROUND_ACTION, message)

      if (message.status == 'done' && message.type == 'move') {
        commit(`content/entry/${[EntryMutations.REMOVE_ENTRY]}`, message.node_id, { root:true })
      }

      if (message.status == 'done' && message.type == 'delete') {
        commit(`content/entry/${[EntryMutations.REMOVE_ENTRY]}`, message.node_id, { root:true })
      }

      return
    }

    // Only the multi-node ZIP operation is allowed to create a background
    // action containing a download URL. The file-service is also sending a
    // URL-bearing callback after a normal upload; that is the duplicate item
    // we must discard. The ordinary "Uploaded <file>" room action contains
    // no URL and continues through the original creation path below.
    if (!isShareDownloadAction(message) && containsHttpUrl(message)) {
      return
    }

    dispatch(BackgroundActions.CREATE_BACKGROUND_ACTION, message)
  },

  async [BackgroundActions.CANCEL_BACKGROUND_ACTION]({ commit }, bgAction) {
    bgAction.cancelSource.cancel('Cancelled by user')

    // Upload actions register a compensating operation once their content
    // node has been prepared. Wait for it before allowing route navigation.
    if (bgAction.onCancel) {
      await bgAction.onCancel()
    }

    commit(BackgroundMutations.REMOVE_BACKGROUND_ITEM, bgAction.bgActionId)
  },

  [BackgroundActions.CLEAR_BACKGROUND_ACTION_LIST]({ commit }) {
    commit(BackgroundMutations.REMOVE_ALL_COMPLETED_BACKGROUND_ACTIONS)
  },

  [BackgroundActions.CLEAR_NEW_ACTIONS_NUMBER]({ commit }) {
    commit(BackgroundMutations.SET_NEW_ACTIONS_NUMBER, 0)
  },
}
